<template>
    <div class="flex flex-row justify-center w-full header-img">
        <div class="justify-center">
            <sc-image :media="fields.image" class="" />
            <p class="text-base"><sc-text :field="fields.text" /></p>
        </div>
    </div>
</template>

<script>
import { Text as ScText, Image as ScImage } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'HeaderImage',
  components: {
      'sc-image': ScImage,
      'sc-text': ScText,
  },
  computed: {
    //fields() {
    //    // rendering.fields are populated from route YAML (disconnected)
    //    // or from Layout Service (integrated)
    //    return this.rendering?.fields || {};
    //},
    imageUrl() {
      const img = this.fields?.image || {};
      // try common shapes used by disconnected/layout service
      return img.src || (img.value && img.value.src) || (img.fields && img.fields.src) || '';
      },
    
  },
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>
